module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"param":{"margin":"margin (Enlarge the detected time range by a number of years on both sides)"}}}')
  delete Component.options._Ctor
}
